<template>
	<section v-editable="blok" class="container" data-component="BasicComponent">
		<div
			class="grid md:grid-cols-12 md:p-10 gap-0 md:gap-6 lg:gap-20 rounded-2.5xl"
			:class="{
				'bg-background-noticeable': blok.background === BackgroundVariants.YELLOW,
				'bg-price-background': blok.background === BackgroundVariants.ORANGE,
			}"
		>
			<div class="md:col-span-7 p-6 sm:p-8 md:p-0">
				<h2 class="typo-h2 mb-4">
					{{ blok.header }}
				</h2>
				<RichText :data="blok.text" />
			</div>
			<div
				class="h-fit md:col-span-5"
				:class="{
					'order-first': blok.shape === ShapeVariants.IMAGE_FIRST,
				}"
			>
				<div
					v-if="blok.image"
					class="md:rounded-2.5xl overflow-hidden col-span-4 md:col-span-3"
					:class="{
						'md:col-start-2': blok.shape !== ShapeVariants.IMAGE_FIRST,
						'relative aspect-[2/1]': blok.imageContain,
						'max-md:rounded-bl-2.5xl max-md:rounded-br-2.5xl': blok.shape !== ShapeVariants.IMAGE_FIRST,
						'max-md:rounded-tl-2.5xl max-md:rounded-tr-2.5xl': blok.shape === ShapeVariants.IMAGE_FIRST,
					}"
				>
					<NuxtPicture
						v-if="blok.image?.filename"
						provider="storyblok"
						width="620"
						:height="blok.imageContain ? 'auto' : 620"
						:modifiers="storyblokFocusModifiers(blok.image.focus)"
						:src="blok.image.filename"
						:alt="blok.image.alt || ''"
						sizes="xs:90vw sm:90vw md:90vw lg:30vw xl:30vw xxl:30vw inf:620px"
						class="block w-full h-full"
						:class="{'absolute inset-0': blok.imageContain}"
						:img-attrs="{class: `w-full ${blok.imageContain ? 'object-center object-contain' : 'h-full'}`}"
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import type {BasicComponentStoryblok} from '@/storyblok/types';

	enum BackgroundVariants {
		YELLOW = 'yellow',
		ORANGE = 'orange',
	}

	enum ShapeVariants {
		IMAGE_FIRST = 'imageFirst',
		IMAGE_LAST = 'imageLast',
	}

	interface Props {
		blok: BasicComponentStoryblok
	}
	defineProps<Props>();
</script>
